/** Dados do controlador e contatos para documentos legais (LGPD). */
export const LEGAL = {
  brand: 'SysMV',
  location: 'Pau dos Ferros, RN, Brasil',
  privacyEmail: 'sysmv.contato@gmail.com',
  lastUpdated: '7 de junho de 2026',
}

export const PRIVACY_EMAIL_SUBJECT = 'Solicitação LGPD — SysMV'
export const PRIVACY_DELETE_SUBJECT = 'Exclusão de dados pessoais — SysMV'

export function privacyMailto(subject = PRIVACY_EMAIL_SUBJECT, body = '') {
  const params = new URLSearchParams()
  if (subject) params.set('subject', subject)
  if (body) params.set('body', body)
  const qs = params.toString()
  return `mailto:${LEGAL.privacyEmail}${qs ? `?${qs}` : ''}`
}
